import { Component, Inject, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../shared/services/apiService.service';
import { SkeletonService } from '../shared/services/skeleton.service';
import { ToastrService } from 'ngx-toastr';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { setImageUrl } from '../fni-modules/shared/helper/common_function';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { secureStorage } from '../shared/services/encryption/secureservice';
import { filter, pairwise } from 'rxjs/operators';
import { RootService } from '../shared/services/root.service';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RegexService } from '../shared/form-validation/regex.service';

@Component({
  selector: 'app-brand-offers',
  templateUrl: './brand-offers.component.html',
  styleUrls: ['./brand-offers.component.scss']
})
export class BrandOffersComponent implements OnInit {
  @ViewChild('successModal') successModal!: TemplateRef<any>;
  sub: Subscription = new Subscription();
  offersData: any = [];
  productLoaded: any = []
  bannerList: any = [];
  environment1 = environment.s3bucket.url;
  maximumSize: any = 6;
  totalItemsOffers: any = 0
  itemsPerPage: any = 10;
  currentPage: any = 1;
  userData: any;
  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    autoplay: true,

    responsiveRefreshRate: 1000000,

    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },

  }
  productDetailList: any;
  enquiryForm!: FormGroup;
  financerData = [
    { financier_name: 'Tata Motors Finance' },
    { financier_name: 'Cholamandalam' },
    { financier_name: ' Yes Bank' },
    { financier_name: 'SBI' },
    { financier_name: 'Sundaram Finance' },
    { financier_name: 'HDB Financial Services' },
    { financier_name: 'HDFC Bank' }

  ];
  disabledFields = false;
  encData = false;
  isSubmitted = false;
  isSuccess = false;
  stateList: any[];
  fieldDisable: boolean =false;
  districtList: any[];
  constructor(private spinner: NgxSpinnerService, private modalService: NgbModal, private apiService: ApiService, public skeletonService: SkeletonService,
    private toastrService: ToastrService, private router: Router, @Inject(PLATFORM_ID) private platformId: Object,
    private localStorage: secureStorage,private rootService:RootService, private behaviourSubject: BehaviourSubjectService,private fb: FormBuilder,
    private regexService: RegexService,
  ) {

     }

     ngOnInit(): void {

      this.currentPage = 1;
      this.userData = this.rootService.getUserData();
      this.getBannerList();
      this.sub.add(this.behaviourSubject.offerDeatil.subscribe((e) => {
        this.currentPage = e ? e : 1
        this.pageChangeoffer(this.currentPage);
      }));
      this.enquiryForm = this.fb.group({
        firstName: ['', Validators.required],
        mobile: ['', [Validators.required, Validators.minLength(10),
          Validators.maxLength(10), Validators.pattern(this.regexService.Phone)]],
        lastName: ['', Validators.required],
        other_financier: [''],
        state: ['', Validators.required],
        district: ['', Validators.required],
        pincode: ["", [Validators.required,Validators.minLength(6),
          Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')]],

      });
      this.enquiryForm.patchValue({ 
        mobile: this.userData?.mobile_number, 
        firstName: this.userData?.first_name,
        lastName :this.userData?.last_name,
        pincode: this.userData?.pincode ? this.userData?.pincode : '',
    });
    }

  getOfferDetails(reqBody:any) {
    try {
      if (isPlatformBrowser(this.platformId)) {

        let data = localStorage.getItem('previousUrl')
        let value = data?.split(',')
        let lob,ppl,pl,model
        if(value){
           lob = value[0]
           ppl = value[1]
           pl = value[2],
           model = value[3]
        }
        let val={
          noOfCampaignOffers:10,
          lob:lob ? lob : '',
          ppl:ppl ? ppl : '',
          pl:pl ? pl : '',
          state:this.userData.state ? this.userData.state : '',
          sortBy: 'campaignSchemePriority',
          sortOrder: 'asc',
          offset:reqBody.offset
        }
        this.spinner.show();
        this.sub.add(this.apiService.getOffersDetailsNew(val).subscribe({
          next: (res: any) => {
            this.productLoaded = true
            this.spinner.hide();
            this.totalItemsOffers=res.totalCount;
            res=res.offers;
            this.offersData=[]
            this.offersData = res;
          },
          error: () => {
            this.spinner.hide();
            this.productLoaded = true
          },
          complete: () => {
            this.spinner.hide();
            this.productLoaded = true
          }
        }))
      }
    } catch (error) {
      this.spinner.hide();
      this.productLoaded = true
    }
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  setFinancierImgUrl(financierId: any) {
    return setImageUrl(financierId);
  }

  async getBannerList() {
    let req = {
      page: "FINANCE",
      offset: 0,
      size: 6,
    }

    await this.sub.add(this.apiService.getBannerListNew(req).subscribe({
      next: (response: any) => {

        if (response.success) {

          this.spinner.hide();
          this.bannerList = response;
          return this.bannerList;
        }
        else {
          this.spinner.hide();
          this.bannerList = [];
          if (response?.data?.msg == "User is not registered.") {

            this.toastrService.warning(response.data.msg || response.msg)
          }
          else {
            this.bannerList = [];

            this.spinner.hide();

          }
          return this.bannerList;

        }
      },
      error: () => {
        this.toastrService.warning("Something went wrong!")

        this.spinner.hide();
        return this.bannerList;

      },
      complete: () => {

      }
    }))
  }



  navigateToOfferDetail(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (JSON.parse(this.localStorage.getItem('productOfferData'))) {
        this.productDetailList =JSON.parse(this.localStorage.getItem('productOfferData'))
        this.productDetailList.financierId = data.tmlSchemeID;
        this.productDetailList.financierName =
          data.financierDetails.crmFinancierName;
        this.localStorage.setItem(
          'productOfferData',
          JSON.stringify(this.productDetailList)
        );
        this.router.navigate(['offer-details'], {
          queryParams: { financierSchemeId: data.financierSchemeId,page:this.currentPage },
        });
      }
      else{
        this.router.navigate(['offer-details'], {
          queryParams: { financierSchemeId: data.financierSchemeId,page:this.currentPage },
        });
      }

    }
  }
  pageChangeoffer(page:any){
this.currentPage=page
page = page - 1;
let reqBody =
{
  "offset": page,
};
this.getOfferDetails(reqBody)
  }
  GetTest(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      let url;
      var dataUrl = data?.banner_link;
      if(dataUrl){
        url = dataUrl?.replace(window.location.origin + '/' + dataUrl);
        this.router.navigateByUrl(url);
      }
    }
  }







  openPopup(): void {
    if (isPlatformBrowser(this.platformId)) {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'success-modal'
    };

    this.modalService.open(this.successModal, ngbModalOptions).result.then(
      (result) => {
      },
      (reason: any) => {
      }
    );
  }
  }



  addressByPincode() {
    this.fieldDisable = false;
    if (this.enquiryForm.value.pincode?.length == 6) {
      this.getAddress(this.enquiryForm.value.pincode);
    }
  }



  getAddress(pincode: string | number) {
    const data = {
      pincode: pincode,
      app_name: 'com.tatamotors.cvonline',
      device_id: '1234',
    };
    this.fieldDisable = false;
    this.sub.add(
      this.apiService.getAddressByPincodeList(data).subscribe({
        next: (response: any) => {
          if (response?.length) {
            this.stateList = [response[0]?.state];
            this.districtList = [response[0]?.district];

            this.enquiryForm.patchValue({
              state: this.stateList[0]?.name || '',
              district: this.districtList[0] || '',
            });
            this.fieldDisable = false;
          } else {
            this.enquiryForm.patchValue({
              state: '',
              district: '',
            });
            this.fieldDisable = true;


            this.toastrService.warning(
              'Address not found for pincode provided.'
            );

          }
        },
        error: (err) => {
          // Log and handle errors here
          console.error('Error fetching address:', err);
          this.toastrService.warning(
            'Address not found for pincode provided.'
          );
        },
      })
    );
  }




 onSubmit(): void {
    this.isSubmitted = true;

    if (this.enquiryForm.invalid) {
      return;
    }

    const formData = this.enquiryForm.value;
    let data = {
    first_name:formData.firstName,
    last_name: formData.lastName,
    mobile_number:formData.mobile,
    state:formData.state,
    district:formData.district,
    lob:"",
    pl:"",
    ppl:"",
    finacer:"",
    is_active:true,
    pincode: formData.pincode
    }
    this.spinner.show();
    this.sub.add(
      this.apiService.addEnquireFinancerData(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.spinner.hide();
            this.openPopup();
            this.enquiryForm.reset();
            this.enquiryForm.patchValue({ 
              state: this.userData.state, 
              mobile: this.userData.mobile_number, 
              firstName: `${this.userData.first_name} ${this.userData.last_name}`,
              pincode: this.userData.pincode ? this.userData.pincode : '' 
          });
          }else{
            this.toastrService.warning("Something went wrong!")
            this.spinner.hide();
            this.enquiryForm.reset();
            this.enquiryForm.patchValue({ 
              state: this.userData.state, 
              mobile: this.userData.mobile_number, 
              firstName: `${this.userData.first_name} ${this.userData.last_name}`, 
              pincode: this.userData.pincode ? this.userData.pincode : '' 
             });
          }
        
        },
        error: () => {
          this.toastrService.warning("Something went wrong!")
        },
        complete: () => {},
      })
    );
  }




  closePopup(): void {
    this.modalService.dismissAll();
    this.enquiryForm.reset();
    this.isSubmitted = false;
    this.enquiryForm.patchValue({ 
      mobile: this.userData.mobile_number, 
      firstName:this.userData.first_name , 
      lastName:this.userData.last_name,
      pincode: this.userData.pincode ? this.userData.pincode : ''
  });  }


  sanitizeInput(input: string): string {
    // Remove HTML tags
    return input.replace(/<\/?[^>]+(>|$)/g, '');
  }

  // Usage in the HTML
  onInput(event: any): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = this.sanitizeInput(inputElement.value);
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe()
    }
  }

}
